@use "~theme/breakpoints";

.alwaysVisible {
  display: inherit;
}

.separator {
  border: 0;
  border-bottom: 1px solid var(--blue-01-at-30);
  margin: {
    left: 24px;
    right: 24px;
    bottom: 24px;
  }

  @include breakpoints.desktop {
    margin: {
      top: 0;
      left: 32px;
      right: 32px;
      bottom: 24px;
    }
  }
}

.agreement {
  margin: 0 24px;

  @include breakpoints.desktop {
    margin: 0 32px;
  }
}

.container {
  padding: 24px 24px 40px;

  @include breakpoints.desktop {
    padding: 32px 40px 40px;
  }
}

.card {
  position: relative;
  display: grid;
  gap: 24px;
  border: 1px solid var(--blue-01-at-30);
  padding: 16px 28px;
  border-radius: 4px;
  background-color: var(--blue-03-at-30);
}
